import {
    Box,
    Paper,
    Stack,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Typography,
} from '@mui/material'
import React from 'react'
import { CTAMap } from '../ctaData'
import useJobCards from '../hooks/useJobCards'
const styleProps = {
    sx: { width: '20%' },
}
const JobCards = () => {
    const { handelTabChange, selectedTab, bookingSummary, helperCards, supervisorCards, technicianCards } =
        useJobCards()
    return (
        <Stack>
            <Tabs value={selectedTab} onChange={handelTabChange}>
                {CTAMap[bookingSummary?.status?.enumValue]?.tabs?.READY_TO_DEPLOY && (
                    <Tab
                        value={'READY_TO_DEPLOY'}
                        label={`Ready To Deploy Heroes (${
                            bookingSummary?.jobCardsStateCount?.filter(
                                (item) => item?.enumValue === 'READY_TO_DEPLOY'
                            )[0]?.count
                        })`}
                    />
                )}
                {CTAMap[bookingSummary?.status?.enumValue]?.tabs?.DEPLOYMENT_COMPLETE && (
                    <Tab
                        value={'DEPLOYMENT_COMPLETE'}
                        label={`Deployed Heroes (${
                            bookingSummary?.jobCardsStateCount?.filter(
                                (item) => item?.enumValue === 'DEPLOYMENT_COMPLETE'
                            )[0]?.count
                        })`}
                    />
                )}
            </Tabs>
            {['RECEIVED', 'CONFIRMED', 'ALLOCATION_PENDING'].includes(bookingSummary?.status?.enumValue) ? (
                <Typography
                    color="gainsboro"
                    variant="h5"
                    style={{
                        margin: '10% auto',
                    }}
                >
                    Allocation has not started yet
                </Typography>
            ) : (
                <>
                    <Box p={2}>
                        <Typography style={{ marginBottom: '20px' }} variant="h5">
                            Helpers ({helperCards?.length})
                        </Typography>

                        <TableContainer component={Paper} variant="outlined">
                            <Table>
                                <TableHead>
                                    <TableRow
                                        sx={{
                                            '*': {
                                                fontWeight: '900 !important',
                                            },
                                        }}
                                    >
                                        <TableCell {...styleProps}>Name</TableCell>
                                        <TableCell {...styleProps}>Phone Number</TableCell>
                                        <TableCell {...styleProps}>City</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {helperCards?.map((helperCard) => (
                                        <TableRow key={helperCard?.jobCardId}>
                                            <TableCell {...styleProps}>{helperCard?.name}</TableCell>
                                            <TableCell {...styleProps}>{helperCard?.phoneNumber}</TableCell>
                                            <TableCell {...styleProps}>{helperCard?.city}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box p={2}>
                        <Typography style={{ marginBottom: '20px' }} variant="h5">
                            Technician ({technicianCards?.length})
                        </Typography>

                        <TableContainer component={Paper} variant="outlined">
                            <Table>
                                <TableHead>
                                    <TableRow
                                        sx={{
                                            '*': {
                                                fontWeight: '900 !important',
                                            },
                                        }}
                                    >
                                        <TableCell {...styleProps}>Name</TableCell>
                                        <TableCell {...styleProps}>Phone Number</TableCell>
                                        <TableCell {...styleProps}>City</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {technicianCards?.map((helperCard) => (
                                        <TableRow key={helperCard?.jobCardId}>
                                            <TableCell {...styleProps}>{helperCard?.name}</TableCell>
                                            <TableCell {...styleProps}>{helperCard?.phoneNumber}</TableCell>
                                            <TableCell {...styleProps}>{helperCard?.city}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Box p={2}>
                        <Typography style={{ marginBottom: '20px' }} variant="h5">
                            Supervisor ({supervisorCards?.length})
                        </Typography>

                        <TableContainer component={Paper} variant="outlined">
                            <Table>
                                <TableHead>
                                    <TableRow
                                        sx={{
                                            '*': {
                                                fontWeight: '900 !important',
                                            },
                                        }}
                                    >
                                        <TableCell {...styleProps}>Name</TableCell>
                                        <TableCell {...styleProps}>Phone Number</TableCell>
                                        <TableCell {...styleProps}>City</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {supervisorCards?.map((helperCard) => (
                                        <TableRow key={helperCard?.jobCardId}>
                                            <TableCell {...styleProps}>{helperCard?.name}</TableCell>
                                            <TableCell {...styleProps}>{helperCard?.phoneNumber}</TableCell>
                                            <TableCell {...styleProps}>{helperCard?.city}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </>
            )}
        </Stack>
    )
}

export default JobCards
